import { useToastStore } from '@/shared/lib/toast';
import { getApiErrorMessage } from './getApiErrorMessage';

/** 서버도 오류도 문구를 못 줄 때 쓰는 기본 문구. 호출부가 저마다 적던 것을 여기 하나로 모은다. */
const DEFAULT_FALLBACK = '잠시 후 다시 시도해주세요.';

/**
 * mutation 이 실패한 것을 사용자에게 알리는 토스트.
 *
 * 실패 토스트는 세 값이 늘 같은 모양이라(제목만 다르고 본문은 서버 문구, 종류는 error)
 * 호출부마다 다시 적을 이유가 없다. `fallback` 은 서버·오류 어느 쪽도 문구를 주지 못할 때만
 * 쓰이므로, 그 자리의 사정이 다를 때만 넘긴다.
 */
export function failToast(title: string, error: unknown, fallback = DEFAULT_FALLBACK): void {
  useToastStore.getState().addToast({
    title,
    body: getApiErrorMessage(error, fallback),
    type: 'error',
  });
}
